import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateCodeBrowserColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

import TemplateFeatureGateTooltip from "./FeatureGate/Tooltip";
import { TemplateActions } from "./FeatureGate/types";

type TemplatesEmptyProps = {
  hasNoResults?: boolean;
  onCreate: () => void;
};

const TemplatesWorkbenchEmpty = ({ hasNoResults, onCreate }: TemplatesEmptyProps) => {
  return (
    <>
      {hasNoResults && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoResults && (
        <EmptyState
          title="You don’t have any templates yet"
          icon={EmptystateCodeBrowserColored}
          caption="Templates enable self-service infrastructure provisioning. Define a reusable configuration once, then let your teammates deploy it through a simple form — without needing to know the underlying infrastructure."
        >
          <Box gap="medium">
            <DocumentationButton to={getDocsUrl("/concepts/template")} label="Documentation" />
            <TemplateFeatureGateTooltip
              action={TemplateActions.CreateTemplate}
              on={({ isDisabled, ...props }) => (
                <Button {...props} variant="primary" onPress={onCreate} disabled={isDisabled}>
                  Create template
                </Button>
              )}
            />
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default TemplatesWorkbenchEmpty;
